import { openDB } from "idb";

export const dbPromise = openDB("newsDB", 3, {
  upgrade(db) {
    const tabs = [ "News_Packages", "News_Data_Fields", "News_RCS_Topic_Codes", "News_3rd_Party_Sources", "News_Reuters_News", "News_3rd_Party_News", "News_Top_News", "News_Online_Reports", "News_Breakingviews", "News_Significant_Development", "News_Japanese_Investor_Brief", "News_Languages", "News_License_PLI" ];
    for (const tab of tabs) {
      if (!db.objectStoreNames.contains(tab)) {
        db.createObjectStore(tab, { keyPath: "content" });
      }
    }
  },
});

export async function addItem(tab, items) {
  const db = await dbPromise;
  for(let item of items){
    db.put(tab, item)
  }
  return ;
}

export async function getAllItems(tab) {
  const db = await dbPromise;
  return db.getAll(tab);
}

export async function getItem(tab, id) {
  const db = await dbPromise;
  return db.get(tab, id);
}

export async function deleteItem(tab, id) {
  const db = await dbPromise;
  return db.delete(tab, id);
}

export async function clearStore(tab) {
  const db = await dbPromise;
  return db.clear(tab);
}

export async function clearAllStores() {
  const db = await dbPromise;
  const storeNames = db.objectStoreNames;
  for (const storeName of storeNames) {
    await db.clear(storeName);
  }
  return true;
}

